<template>
    <div>
        <div class="xinz">
        </div>
        <div>
            <el-form :inline="true"  class="demo-form-inline" @keyup.native.enter="getCalendarTaskList" size="small">
                <el-form-item label="">
                    <el-select v-model="serchSalesId"  filterable clearable :placeholder="this.$t('m.t_salesName')" >
                        <el-option
                                v-for="item in salesList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            <span style="float: left">{{ item.name }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px;text-align: left;margin-left:10px;">{{ item.loginName }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item >
                    <el-date-picker
                            v-model="getTaskDate"
                            type="date"
                            placeholder="日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getCalendarTaskList()"><i class="fa fa-search" /> {{$t('m.b_query')}}</el-button>
                    <el-button type="primary" @click="goBack()">返回</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div>
            <el-table :header-cell-style="{background:'#4B78FF',color:'#FFFFFF'}"
                      v-loading="tableloading"
                      @selection-change="handleSelectionChange"
                      :data="calenTaskList"
                      :empty-text="$t('m.t_nodata')"
                      stripe
                      border
                      class="dataListTable">
                <el-table-column
                        prop="salesName"
                        align="left"
                        width="120"
                        :label="$t('m.t_salesName')">
                </el-table-column>
                <el-table-column
                        prop="place"
                        align="left"
                        width="200"
                        :label="$t('m.t_place')">
                </el-table-column>
                <el-table-column
                        prop="startDate"
                        align="right"
                        width="80"
                        :label="$t('m.t_calendarStartdate')">
                </el-table-column>
                <el-table-column
                        prop="endDate"
                        align="right"
                        width="80"
                        :label="$t('m.t_calendarEnddate')">
                </el-table-column>
                <el-table-column
                        prop="taskDate"
                        align="right"
                        width="100"
                        :label="$t('m.t_taskDate')">
                    <template slot-scope="scope">
                        <template v-if="scope.row.taskDate!=0">
                            {{scope.row.taskDate*1000 | date('%Y-%m-%d') }}
                        </template>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="remark"
                        align="left"
                        :label="$t('m.t_remarks')">
                </el-table-column>
               <!-- <el-table-column
                        prop="id"
                        align="center"
                        width="100"
                        :label="$t('m.b_opt')">
                    <template slot-scope="scope">
                        <template>
                            <el-dropdown>
                                <el-button size="small" type="primary">
                                    <i class="fa fa-mouse-pointer"/> {{$t('m.b_opt')}}
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item size="small" type="primary" @click.native="taskEdit(scope.$index, scope.row)" v-if="custTaskEdit" ><i class="fa fa-edit"/>{{$t('m.b_edit')}}</el-dropdown-item>
                                    <el-dropdown-item size="small" type="primary" @click.native="deleteTask(scope.$index, scope.row)" v-if="custTaskDelete"><i class="fa fa-trash"/> {{$t('m.t_delete')}}</el-dropdown-item>
                                    <el-dropdown-item size="small" type="primary" @click.native="fileListEdit(scope.row)" v-if="canFile"><i class="fa fa-cloud-upload"/> {{$t('m.t_enclosureadmin')}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </template>
                </el-table-column>-->
            </el-table>
        </div>
        <div class="pagination">
            <el-pagination
                    layout="total, prev, pager, next"
                    @current-change="custTaskPageChange"
                    :current-page.sync="pager.page"
                    :page-size="pager.size"
                    :total="pager.total">
            </el-pagination>
        </div>


    </div>
</template>

<script>
    import axios from 'axios'
    import {getCalendarTaskList,getStaffAllList} from '../api/api'
    export default {
        data() {

            return {
                pickerOptions0:{
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                //查詢條件
                serchSalesId:"",
                getTaskDate:'',
                pager:{
                    page:0,
                    size:10,
                    total:0
                },
                calenTaskList:[],
                salesList:[],
                tableloading:false,
            }
        },
        methods: {
            goBack(){
                this.$router.push({
                    name:'行事曆',
                    params:{str:new Date().getTime()}
                })
                this.$store.commit("closeTab","calenList");
            },
            custTaskPageChange(val){
                this.getCalendarTaskList();
            },handleItemChange(val){
            },
            handleSelectionChange(val){
                this.selectionItems=val;
            },
            getCalendarTaskList(){
                this.tableloading=true;
                var params={page:this.pager.page,size:this.pager.size,salesId:this.serchSalesId,taskDate:this.getTaskDate};
                if(params.taskDate!=null && params.taskDate!=''){
                    params.taskDate = parseInt(new Date(params.taskDate).getTime()/1000);
                }
                return getCalendarTaskList(params).then(data=>{
                    let {data:res={}}=data;
                    if(res.errcode==200){
                        let {size,page,total,data:items=[]}=res.data;
                        this.calenTaskList=items;
                        this.pager.total=total;
                        this.pager.page=page;
                        this.pager.size=size;
                        this.tableloading=false;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                });
            },
            resetForm(formName){
                if (this.$refs[formName]!==undefined) {
                    this.$refs[formName].resetFields();
                }
            }
        },
        mounted() {
        },
        activated(){
            this.getCalendarTaskList();
            getStaffAllList().then(data=>{
                let {data:res={}}=data;
                this.salesList=res.data;
            });
        },
        computed: {

        }
    }

</script>

<style lang="scss">
    .menu{
        .right{
            float: right;
        }
    }
    .el-tag + .el-tag {
        margin-left: 5px;
    }
    .dataListTable .cell{ white-space:nowrap; }
</style>



// WEBPACK FOOTER //
// src/views/CalendarList.vue